import { render, staticRenderFns } from "./UserInfoCard.vue?vue&type=template&id=8f0393c0&scoped=true"
import script from "./UserInfoCard.vue?vue&type=script&lang=js"
export * from "./UserInfoCard.vue?vue&type=script&lang=js"
import style0 from "./UserInfoCard.vue?vue&type=style&index=0&id=8f0393c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0393c0",
  null
  
)

export default component.exports